  import React, { useEffect, useState } from "react";
  import {
    Alert,
    FormControl,
    InputLabel,
    MenuItem,
    Select
  } from "@mui/material";

  import { FrmColorTelaio } from "./frm_color_telaio";
  import { useChiusure } from "../../provider/chiusure_provider";
  import { Aperture, ChiusuraType, Verso, VetroType } from "../../../../../models/pergola_configuration";
import { useConfigurationsServicePergola } from "../../../../../services/pergola_service";
import { PergolaConfigurationBuilderState } from "../../../../../../store/reducers/pergola_configuration_builder";
import { getCurrentUser } from "../../../../../core/common_functions";
import { useStoreSelector } from "../../../../../../hooks/StoreHooks";

  interface Accessorio {
    sku: string;
    notes: string;
  }

  interface Props {
    tipoChiusura: ChiusuraType;
    tipoVetro: VetroType;
    apertura: Aperture;
    coloreTelaioNsRal: string;
    coloreTelaioRal: string;
    sistema_chiusura: string | undefined;
    vie: number;
    verso: Verso;
    lunghezzaVetrata: number;
    accessori: Accessorio[];
    handleChange: (field: string, value: any) => void;
  }
  interface VieItem {
    vie: string;
  }
  export const FrmChiusuraMaia: React.FC<Props> = ({
    tipoChiusura,
    tipoVetro,
    coloreTelaioNsRal,
    coloreTelaioRal,
    sistema_chiusura,
    apertura,
    verso,
    vie,
    lunghezzaVetrata,
    accessori,
    handleChange
  }) => {
    const chiusureProvider = useChiusure();
    const codice = sistema_chiusura;
    const cg = useConfigurationsServicePergola();
    const { base, pergolaConfigurationBuilder } = useStoreSelector(store => store);
    const currentUser = getCurrentUser(base);
    const [imgElement, setImgElement] = useState<JSX.Element | null>(null);
    const [vieDisponibili, setVieDisponibili] = useState<number[]>([]);
    const [vieLoading, setVieLoading] = useState<boolean>(true);
    const [needExtraTrave, setNeedExtraTrave] = useState<boolean>(false);

    useEffect(() => {
      const loadNeedExtra = async () => {
        const config = pergolaConfigurationBuilder.configuration;
        if (!config?.configurationId) return;

        const tolleranza = 0.01;
        const larghezzaSoletta = config.dimensioni.larghezza / 1000;
        const lunghezzaSoletta = config.dimensioni.profondita / 1000;

        let nstacchi = Math.floor(larghezzaSoletta / 4.1);
        if (Math.abs(nstacchi * 4.1 - larghezzaSoletta) > tolleranza) nstacchi += 1;
        let nstacchiy = Math.floor(lunghezzaSoletta / 7);
        if (Math.abs(nstacchiy * 7 - lunghezzaSoletta) > tolleranza) nstacchiy += 1;

        if (nstacchi <= 0 || nstacchiy <= 0) return;

        const stepX = larghezzaSoletta / nstacchi;
        const stepY = lunghezzaSoletta / nstacchiy;

        try {
          const res = await cg.getNeedExtra(currentUser, config.configurationId, stepX * 1000, stepY * 1000);
          setNeedExtraTrave(res);
        } catch {
          setNeedExtraTrave(false);
        }
      };

      loadNeedExtra();
    }, [pergolaConfigurationBuilder.configuration]);
    useEffect(() => {
      const loadVie = async () => {
        setVieLoading(true);
        const result = await getVieDisponibili();
        if (result) {
          setVieDisponibili(result);
          if (result.length > 0) {
            const minVia = Math.min(...result);
            if (!result.includes(vie)) {
              handleChange("vie", minVia);
            }
          } else {
            handleChange("vie", undefined);
          }
        }
        setVieLoading(false);
      };

      loadVie();
    }, [lunghezzaVetrata, apertura, tipoVetro, pergolaConfigurationBuilder.configuration]);

    const getVieDisponibili = async () => {
      if(pergolaConfigurationBuilder.configuration){
        const sottrazione_trave = 160 + (needExtraTrave ? 135 : 0)
        const data = {width: lunghezzaVetrata,heigth: pergolaConfigurationBuilder.configuration?.dimensioni.altezza-sottrazione_trave,tipo_vetro: tipoVetro,apertura: apertura};
        const vieM =await cg.getVieMaia(
          currentUser,
          pergolaConfigurationBuilder.configuration.configurationId,
          data
        );
        const vieArray = (vieM as VieItem[]).map(item => parseInt(item.vie, 10));
        return vieArray;
      }
      if (apertura === Aperture.centrale) {
        return [2, 3, 4, 5].filter((num) => {
          if (num === 2) return lunghezzaVetrata >= 2000 && lunghezzaVetrata <= 6000;
          if (num === 3) return lunghezzaVetrata >= 3200 && lunghezzaVetrata <= 7200;
          if (num === 4) return lunghezzaVetrata >= 3600 && lunghezzaVetrata <= 7200;
          if (num === 5) return lunghezzaVetrata >= 5200 && lunghezzaVetrata <= 7200;
          return false;
        });
      }

      return [2, 3, 4, 5].filter(
        (num) =>
          num * 800 <= lunghezzaVetrata &&
          !(num * 1400 < lunghezzaVetrata)
      );
    };

    useEffect(() => {
      console.log(lunghezzaVetrata)
      if (codice && chiusureProvider) {
        chiusureProvider.getChiusuraImgPreview(codice).then(img => {
          if (img) {
            setImgElement(<img src={img.src} alt="" style={{ width: 32, height: 32 }} />);
          } else {
            setImgElement(null);
          }
        });
      } else {
        setImgElement(null);
      }
    }, [codice, chiusureProvider]);

    return (
      <>
        <FormControl fullWidth className="mt-3">
          <InputLabel id="tipo_vetro_label">Tipo di vetro</InputLabel>
          <Select
            labelId="tipo_vetro_label"
            id="tipo_vetro"
            name="tipo_vetro"
            value={tipoVetro ?? VetroType.vetro_camera_25mm_6_16_6_be}
            label="Tipo di vetro"
            onChange={(e) => handleChange("tipo_vetro", e.target.value)}
          >
            <MenuItem value={VetroType.vetro_temperato_10mm}>Vetro temperato 10mm</MenuItem>
          </Select>
        </FormControl>

        <FrmColorTelaio
          coloreTelaioNsRal={coloreTelaioNsRal}
          coloreTelaioRal={coloreTelaioRal}
          setFieldValue={(field, value) => handleChange(field, value)}
        />

        <h6 className="text-primary mt-2">Apertura</h6>
        <FormControl fullWidth className="mt-3">
          <InputLabel id="apertura_label">Verso Apertura</InputLabel>
          <Select
            labelId="apertura_label"
            id="apertura"
            name="apertura"
            value={apertura || Aperture.laterale}
            label="Verso Apertura"
            onChange={(e) => handleChange("apertura", e.target.value)}
          >
            <MenuItem value={Aperture.laterale}>Laterale</MenuItem>
            <MenuItem value={Aperture.centrale}>Centrale</MenuItem>
          </Select>
        </FormControl>
        {apertura === Aperture.laterale && (<>
              <FormControl fullWidth className="mt-3">
                <InputLabel id="apertura_label">Direzione Apertura (Vista Interna)</InputLabel>
                <Select
                  labelId="apertura_label"
                  id="apertura"
                  name="apertura"
                  value={verso || Verso.destra}
                  label="Direzione Apertura (Vista Interna)"
                  onChange={(e) => handleChange("verso", e.target.value)}
                >
                  <MenuItem value={Verso.destra}>Destra</MenuItem>
                  <MenuItem value={Verso.sinistra}>Sinistra</MenuItem>
                  <MenuItem value={Verso.ambe}>Destra/Sinistra</MenuItem>
                </Select>
              </FormControl>
        </>)}  
        {vieLoading ? (
          <p className="text-muted small mt-3">Ricerca vie in corso...</p>
        ) : vieDisponibili.length === 0 ? (
          <Alert severity="warning" className="mt-3">
            Nessuna via disponibile per le dimensioni selezionate
          </Alert>
        ) : (
          <FormControl fullWidth className="mt-3">
            <InputLabel id="vie_label">Vie</InputLabel>
            <Select
              labelId="vie_label"
              id="vie"
              name="vie"
              value={vie ?? Math.min(...vieDisponibili)}
              label="Vie"
              onChange={(e) => handleChange("vie", e.target.value)}
            >
              {vieDisponibili.map((num) => (
                <MenuItem key={num} value={num}>
                  {num}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        )}



        {tipoChiusura === ChiusuraType.vetrate_scorrevoli_maia && apertura !== Aperture.centrale && (
          <>
            <h6 className="text-primary mt-2">Sistema di chiusura</h6>
            <FormControl fullWidth className="mt-3">
              <InputLabel id="sistema_chiusura_label">Sistema di chiusura</InputLabel>
              <Select
                labelId="sistema_chiusura_label"
                id="sistema_chiusura"
                name="sistema_chiusura"
                value={sistema_chiusura ?? "ACCMBV12"}
                label="Sistema di chiusura"
                onChange={(e) => handleChange("sistema_chiusura", e.target.value)}
              >
                <MenuItem value="ACCMBV12">Maniglia rettangola inox ad incollare con chiusura push - push (di serie)</MenuItem>
                <MenuItem value="ACCMBV10">Serratura con pomello, chiave e riscontro (con maggiorazione)</MenuItem>
              </Select>
            </FormControl>
          </>
        )}
      </>
    );
  };
